// Badge — pill colorida pra status. Variants explícitas (OCP).
import type { HTMLAttributes, ReactNode } from 'react';
import styles from './Badge.module.css';
import { cn } from '@/lib/utils/cn';

export type BadgeVariant =
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'purple'
  | 'gray'
  | 'green'
  | 'primary';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  leadingIcon?: ReactNode;
  children: ReactNode;
}

const variantClass: Record<BadgeVariant, string> = {
  success: styles.success,
  warning: styles.warning,
  danger: styles.danger,
  info: styles.info,
  purple: styles.purple,
  gray: styles.gray,
  green: styles.green,
  primary: styles.primary,
};

export function Badge({ variant = 'gray', leadingIcon, children, className, ...rest }: BadgeProps) {
  return (
    <span className={cn(styles.badge, variantClass[variant], className)} {...rest}>
      {leadingIcon && <span className={styles.icon}>{leadingIcon}</span>}
      {children}
    </span>
  );
}
